export const getDefaultValue = (
  inputValue: string,
  maskPattern: string,
  maskChar: string
): string => {
  const maskOnlyPattern = maskPattern.replace(/9/g, maskChar);
  return !inputValue || inputValue === maskOnlyPattern
    ? maskPattern.replace(/9/g, '0')
    : inputValue;
};

export const splitMaskAndInput = (
  maskPattern: string,
  inputValue: string
): { maskParts: string[]; inputParts: string[] } => {
  const maskParts = maskPattern.split('.');
  const [inputInteger = '', inputDecimal = ''] = inputValue.split('.');
  return { maskParts, inputParts: [inputInteger, inputDecimal] };
};

export const formatIntegerPart = (inputInteger: string, integerMask: string): string => {
  return inputInteger.padEnd(integerMask.length, '0').slice(0, integerMask.length);
};

export const formatDecimalPart = (inputDecimal: string, decimalMask: string): string => {
  return inputDecimal.padEnd(decimalMask.length, '0').slice(0, decimalMask.length);
};

export const formatInputValue = (
  inputValue: string,
  maskPattern: string,
  maskChar: string
): string => {
  const defaultValue = getDefaultValue(inputValue, maskPattern, maskChar);
  if (defaultValue !== inputValue) {
    return defaultValue;
  }

  const { maskParts, inputParts } = splitMaskAndInput(maskPattern, inputValue);
  const integerMask = maskParts[0] || '';
  const finalInteger = formatIntegerPart(inputParts[0], integerMask);

  let finalValue = finalInteger;
  if (maskParts[1]) {
    const finalDecimal = formatDecimalPart(inputParts[1], maskParts[1]);
    finalValue = `${finalInteger}.${finalDecimal}`;
  }

  return finalValue.replace(new RegExp(maskChar, 'g'), '0');
};
